'use client';
export {
  Label,
  //
  Root,
} from './Label';
export type { LabelProps } from './Label';
